import supabase from "artifact/supabase";
import connected from "standard/connected";
import define from "standard/define";
import paint from "standard/paint";
import trait from "standard/trait";
import willPaint from "standard/willPaint";
import style from "./style";

@define("m-class")
class Class extends HTMLElement {
  #classes = [];

  @connected
  @paint
  [trait.template]() {
    return `
      <div class="${style.class__container}">
        <label class="${style.class__label}" for="class">Turma *</label>
        <select id="class" name="class" class="${style.class__select}" required>
          <option class="${style.class__option}" value="" disabled selected>Selecionar turma</option>
          ${this.#classes.map(
            (x) => `
              <option value="${x.id}">${x.name}</option>
            `,
          )}
        </select>
      </div>
    `;
  }

  @willPaint
  async [trait.fetch]() {
    const { data } = await supabase
      .from("class")
      .select("*, level_of_education!inner(*, grade!inner(*))")
      .eq("level_of_education.grade.school_id", this.dataset.school)
      .order("name", { ascending: true });

    this.#classes = data;

    return this;
  }
}

export default Class;
